import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { ResizableBox } from "react-resizable";
import { Box } from "@mui/material";

import { PdfDocument } from "components/pdf-preview/components";
import { MaybeNull } from "types";

import { PurchasePdfEmptyData } from "./components";
import "./css/style.css";

const DEFAULT_WIDTH = 612;

interface PdfPreviewProps {
  documentId: MaybeNull<number>;
  downloadUrl: MaybeNull<string>;
  scale: number;
  setFileName: any;
}

export const PurchasePdfPreview: FunctionComponent<PdfPreviewProps> = ({
  documentId,
  downloadUrl,
  scale,
  setFileName,
}) => {
  const [resizeWidth, setResizeWidth] = useState(DEFAULT_WIDTH);
  const [containerWidth, setContainerWidth] = useState(DEFAULT_WIDTH);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight - 180);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => setWindowHeight(window.innerHeight - 180);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const el = containerRef.current;
    let observer: ResizeObserver | undefined;
    if (el) {
      observer = new ResizeObserver(([entry]) => {
        setContainerWidth(entry.contentRect.width);
      });
      observer.observe(el);
    }
    return () => observer?.disconnect();
  }, []);

  const file = downloadUrl;

  const onResize = (_: any, { size }: any) => {
    setResizeWidth(size.width);
  };

  return (
    <ResizableBox
      height={windowHeight}
      width={resizeWidth}
      onResize={onResize}
      minConstraints={[DEFAULT_WIDTH, windowHeight]}
      maxConstraints={[900, windowHeight]}
      resizeHandles={["e"]}
    >
      <Box
        ref={containerRef}
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          borderRadius: 2,
          minWidth: DEFAULT_WIDTH,
          height: "100%",
          overflowY: "auto",
          overflowX: "auto",
          boxSizing: "border-box",
          p: 2,
          pr: 4,
          justifyContent: !file ? "center" : "flex-start",
        }}
      >
        {!file ? (
          <PurchasePdfEmptyData fileName={setFileName} documentId={documentId} />
        ) : (
          <PdfDocument
            width={containerWidth}
            scale={scale}
            file={file}
          />
        )}
      </Box>
    </ResizableBox>
  );
};
